/* A visit's duration, formatted. Its own module rather than `module/visit/sections.js`, which is
   where it would naturally live: that file imports `LeafletMap`, so reaching into it from the
   visits list and the merchandiser detail would pull Leaflet into two more entry bundles. Same
   reasoning as `util/answer-fields.js`. */
import { VISIT_PAGE } from "../config/lang";
import { translate } from "./util";

/** `time_spent` as "1h 30m" / "58m", or "" when there is nothing to show.
 *
 * ⚠ `time_spent` is a duration in SECONDS and it arrives as a STRING: the model's `time_spent` is a
 * Python `timedelta` property exposed through a `ReadOnlyField`, and DRF's encoder renders that as
 * `str(total_seconds())`. So it is coerced, never trusted as a number — interpolating it raw printed
 * "58.0", and reading it as minutes labelled 354359 seconds (98h 26m) as "354359.0 хв"
 * (PICSELL-1574 #4).
 *
 * Callers own their own empty state, which is why "" comes back rather than a dash: the visits list
 * wants `—`, the visit detail falls back to the start time.
 */
export const formatDuration = (value, lang) => {
  const seconds = Number(value) || 0;
  if (!seconds) return "";
  const t = key => translate(VISIT_PAGE, key, lang);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);
  return hours ? `${hours}${t("h_short")} ${minutes}${t("m_short")}` : `${minutes}${t("m_short")}`;
};
